export var LevelFlag;
(function (LevelFlag) {
    LevelFlag[LevelFlag["BLOCK_UNIQUE_TAGS"] = 1] = "BLOCK_UNIQUE_TAGS";
    LevelFlag[LevelFlag["IS_MINIGAME"] = 2] = "IS_MINIGAME";
})(LevelFlag || (LevelFlag = {}));
